export default {
  title: 'Dashboard',
  totalInvoices: 'Total Invoices',
  totalAmount: 'Total Amount',
  totalOrders: 'Total Orders',
  totalShipForMe: 'Total Ship For Me',
  totalRevenue: 'Total Revenue',
  averageOrderValue: 'Average Order Value',
  invoiceStatus: 'Invoice Status',
  invoiceAmount: 'Invoice Amount Distribution',
  orderStatus: 'Order Status Distribution',
  orderTypes: 'Order Types Distribution',
  revenue: 'Revenue',
  revenueOverTime: 'Revenue Over Time',
  statistics: 'Statistics',
  summary: 'Summary',
  charts: 'Charts',
  loading: 'Loading dashboard...',
  error: 'Error loading dashboard',
  noData: 'No data available',
  iqdExchangeRate: 'IQD Exchange Rate',
  iqdExchangeRateDate: 'Last updated',
  iqdExchangeRateNotAvailable: 'N/A',
};

